export default __webpack_public_path__ + "static/media/avatar_panda2.b244c04c.mp3";